import type { ClaimLabelOption } from '@/admin/hooks/use-claims'

/** The options a picker or filter may offer: retired labels are display-only. */
export function selectableLabelOptions(
  options: ClaimLabelOption[],
): ClaimLabelOption[] {
  return options.filter((o) => o.active !== false)
}
